import { createApp, reactive } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import './utils/toastUtils';
import i18n from './i18n';
import 'vuetify/styles';
import router from './router';
import axios from '@/plugins/axios';
import Vue3Toastify, { toast, type ToastContainerOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import vuetify from '@/plugins/vuetify';
import keycloakPlugin from './plugins/keycloak';
import apiUrls from '@/config/apiUrls';
import { setPathPrefix } from '@/config/runtimeConfig';

const configUrl = (apiUrls.getConfData as (origin: string) => string)(window.location.origin);
axios
  .get(configUrl)
  .then((response) => {
    if (response.status === 200) {
      const keycloakConfig = {
        url: response.data['ria.web.config.oauth.realm.base-url'],
        realm: response.data['ria.web.config.oauth.realm.name'],
        clientId: response.data['ria.web.config.oauth.clientid'],
      };
      keycloakPlugin.createKeycloakInstanceFromConfig(keycloakConfig);

      if (
        response.data['ria.rest.url.path'] !== undefined &&
        response.data['ria.rest.url.path'] !== null
      ) {
        setPathPrefix(response.data['ria.rest.url.path']);
      }
    } else {
      keycloakPlugin.createKeycloakInstanceFromJson('/keycloak.json');
    }

    return keycloakPlugin.onKeycloakReady();
  })
  .catch(() => {
    keycloakPlugin.createKeycloakInstanceFromJson('/keycloak.json');
    return keycloakPlugin.onKeycloakReady();
  })
  .then(() => {
    const app = createApp(App);
    const pinia = createPinia();
    app.config.globalProperties.axios = axios;

    app.use(pinia);
    app.use(i18n);
    app.use(router);
    app.use(vuetify);
    app.use(Vue3Toastify, {
      autoClose: 5000,
      theme: 'dark',
      closeOnClick: true,
      position: toast.POSITION.BOTTOM_RIGHT,
    } as ToastContainerOptions);

    app.mixin({
      data() {
        return {
          breadcrumbs: reactive([]),
        };
      },
      watch: {
        $route(to) {
          if (to.meta?.breadcrumb) {
            this.breadcrumbs = to.meta.breadcrumb?.map((bc: any) => ({
              ...bc,
              route: bc.href.replace(':id', to.params.id),
            }));
          }
        },
      },
      created() {
        if (this.$route.meta.breadcrumb) {
          this.breadcrumbs = this.$route.meta.breadcrumb?.map((bc: any) => ({
            ...bc,
            route: bc.href.replace(':id', this.$route.params.id),
          }));
        }
      },
    });

    app.mount('#app');
  })
  .catch((error) => {
    console.error('App startup failed:', error);
  });
